import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { LoaderService } from '../services/loader.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss']
})
export class LoaderComponent implements OnInit {
  showLoader = false;

  imageSrc = "";
  msg: any;
  $loaderMsg: Subscription;
  constructor(public loader: LoaderService, private cdr: ChangeDetectorRef,) {
    this.imageSrc = window.location.origin;
  }

  ngOnInit(): void {
    this.loader.isLoading().subscribe((value) => {
      this.$loaderMsg = this.loader.loaderMsg.subscribe((resMsg: any) => {
        this.msg = resMsg;
      })
      this.showLoader = value;
      this.cdr.detectChanges();
    });
  }

  ngOnDestroy(): void {
    this.$loaderMsg.unsubscribe();
  }
}
